<template>
  <v-container v-if="user">
    <v-card>
      <v-card-title class="text-center teal lighten-3 accent-4 white--text">
        Reporte ventas laboratorio
        <v-spacer></v-spacer>
        <!-- <v-btn @click="verData" class="mr-2" color="primary">data</v-btn> -->
      </v-card-title>
      <v-row class="mx-2 mt-1">
        <v-col cols="12" lg="4" md="5">
          <v-select
            v-model="laboratorioSelected"
            :items="laboratorios"
            item-value="value"
            label="Laboratorio"
            placeholder="Selecciona laboratorio"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div class="d-flex flex-wrap">
            <v-checkbox
              v-for="(sucursal, index) in sucursales"
              :key="sucursal.value + index"
              :label="sucursal.text"
              :value="sucursal.value"
              v-model="sucursalesSeleccionadas"
              class="ml-5 mr-5"
            ></v-checkbox>
          </div>
        </v-col>

        <v-col cols="2">
          <v-btn @click="getReporte" small class="mt-5" :loading="loadingBtn"
            >Buscar</v-btn
          >
        </v-col>
      </v-row>
      <!-- Grafico por mes y trimestre -->
      <v-row
        v-if="dataLaboratorio.length > 0"
        justify="center"
        class="mx-2 mt-1"
      >
        <v-col cols="12" xl="8">
          <VentasPorMes
            :chartSeries="datosChartMes"
            :datosDiferencia="datosDiferenciaMes"
          ></VentasPorMes>
        </v-col>
        <v-col cols="12" xl="8">
          <VentasPorTrimestre
            :chartSeries="datosChartTrimestre"
            :datosDiferencia="datosDiferenciaTrimestre"
          >
          </VentasPorTrimestre>
        </v-col>
      </v-row>

      <!-- Tabla de comparacion -->
      <v-card
        class="ma-5 pa-5"
        justify="center"
        v-if="dataLaboratorio.length > 0"
      >
        <v-row
          v-if="dataLaboratorio.length > 0"
          justify="center"
          class="mx-5 mt-5"
        >
          <!-- Selector para cambiar entre tablas de comparación -->
          <v-col cols="12" md="auto">
            <v-select
              v-model="tablaSeleccionada"
              :items="tablas"
              label="Seleccionar tipo de comparación"
            ></v-select>
          </v-col>
          <v-col v-if="tablaSeleccionada === 'Por Sucursal'" cols="12" md="12">
            <v-card class="pa-2">
              <v-card-title> Comparación por Sucursal </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-select
                      v-model="selectedMonth"
                      :items="meses"
                      label="Mes"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-progress-circular
                  v-if="loadingTable"
                  indeterminate
                  color="primary"
                  class="mx-auto"
                ></v-progress-circular>
                <v-data-table
                  :headers="headers"
                  :items="comparacionPorSucursal"
                  :items-per-page="6"
                  item-key="sucursal"
                  hide-default-footer
                  no-data-text="No hay resultados"
                >
                  <template v-slot:[`item.añoAnterior`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoAnterior) }}
                  </template>
                  <template v-slot:[`item.añoActual`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoActual) }}
                  </template>
                  <template v-slot:[`item.diferencia`]="{ item }">
                    <strong
                      :class="
                        item.diferencia < 0
                          ? 'red--text text--lighten-1'
                          : 'green--text text--lighten-1'
                      "
                      >{{ "$" + formatoPrecio(item.diferencia) }}</strong
                    >
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Condicional para mostrar las tablas dinámicas -->
          <v-col
            v-if="tablaSeleccionada === 'Clientes de Sucursal'"
            cols="12"
            md="12"
          >
            <v-card class="pa-2">
              <v-card-title>Comparación Clientes de Sucursal</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-select
                      v-model="selectedMonth2"
                      :items="meses"
                      label="Mes"
                      :disabled="activarFiltroFecha === true"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch
                      v-model="activarFiltroFecha"
                      label="Año hasta la fecha"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch v-model="quitarFiltros" label="Año completo">
                    </v-switch>
                  </v-col>
                </v-row>
                <v-progress-circular
                  v-if="loadingTable"
                  indeterminate
                  color="primary"
                  class="mx-auto"
                ></v-progress-circular>
                <v-data-table
                  :headers="headersClientes"
                  :items="clientesSucursalFiltrados"
                  :items-per-page="10"
                  :search="search"
                  item-key="(item) => `${item.sucursal}-${item.razon_social}`"
                  no-data-text="No hay resultados"
                  @click:row="irTablaProductosClientes"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-col cols="3" class="ml-4">
                        <v-text-field
                          v-model="search"
                          density="compact"
                          label="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          variant="solo-filled"
                          flat
                          hide-details
                          single-line
                        />
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="3" class="ml-4">
                        <v-select
                          v-model="filtroSucursal"
                          :items="sucursalesDisponibles"
                          item-text="text"
                          item-value="value"
                          label="Filtrar por sucursal"
                          outlined
                          class="ml-2"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.añoAnterior`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoAnterior) }}
                  </template>
                  <template v-slot:[`item.añoActual`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoActual) }}
                  </template>
                  <template v-slot:[`item.diferencia`]="{ item }">
                    <strong
                      :class="item.diferencia < 0 ? 'red--text' : 'green--text'"
                    >
                      {{ "$" + formatoPrecio(item.diferencia) }}
                    </strong>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            v-if="tablaSeleccionada === 'Productos de Sucursal'"
            cols="12"
            md="12"
          >
            <v-card class="pa-2">
              <v-card-title>Comparación Productos de Sucursal</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-select
                      v-model="selectedMonth3"
                      :items="meses"
                      label="Mes"
                      :disabled="activarFiltroFecha2 === true"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch
                      v-model="activarFiltroFecha2"
                      label="Año hasta la fecha"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch v-model="quitarFiltros2" label="Año completo">
                    </v-switch>
                  </v-col>
                </v-row>
                <v-progress-circular
                  v-if="loadingTable"
                  indeterminate
                  color="primary"
                  class="mx-auto"
                ></v-progress-circular>
                <v-data-table
                  :headers="headersProductos"
                  :items="productosSucursalFiltrados"
                  :search="search2"
                  :items-per-page="10"
                  item-key="producto"
                  no-data-text="No hay resultados"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-col cols="4" class="ml-4">
                        <v-text-field
                          v-model="search2"
                          density="compact"
                          label="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          variant="solo-filled"
                          flat
                          hide-details
                          single-line
                        />
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4" class="ml-4">
                        <v-select
                          v-model="filtroSucursal2"
                          :items="sucursalesDisponibles2"
                          item-text="text"
                          item-value="value"
                          label="Filtrar por sucursal"
                          outlined
                          class="ml-2"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </template>

                  <template v-slot:[`item.añoAnterior`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoAnterior) }}
                  </template>
                  <template v-slot:[`item.añoActual`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoActual) }}
                  </template>
                  <template v-slot:[`item.diferencia`]="{ item }">
                    <strong
                      :class="item.diferencia < 0 ? 'red--text' : 'green--text'"
                    >
                      {{ "$" + formatoPrecio(item.diferencia) }}
                    </strong>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            v-if="tablaSeleccionada === 'Productos de Clientes'"
            cols="12"
            md="12"
          >
            <v-card class="pa-2">
              <v-card-title>Comparación Productos de Clientes</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="auto">
                    <v-select
                      v-model="selectedMonth4"
                      :items="meses"
                      label="Mes"
                      :disabled="activarFiltroFecha3 === true"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch
                      v-model="activarFiltroFecha3"
                      label="Año hasta la fecha"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="auto">
                    <v-switch v-model="quitarFiltros3" label="Año completo">
                    </v-switch>
                  </v-col>
                </v-row>
                <v-progress-circular
                  v-if="loadingTable"
                  indeterminate
                  color="primary"
                  class="mx-auto"
                ></v-progress-circular>
                <v-data-table
                  :headers="headersProductosClientes"
                  :items="productosClientesFiltrados"
                  :items-per-page="10"
                  :search="search3"
                  item-key="(item) => `${item.nombre}-${item.razon_social}`"
                  no-data-text="No hay resultados"
                >
                  <template v-slot:top>
                    <v-row>
                      <v-col cols="4" class="ml-4">
                        <v-text-field
                          v-model="search3"
                          density="compact"
                          label="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          variant="solo-filled"
                          flat
                          hide-details
                          single-line
                        />
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4" class="ml-4">
                        <v-autocomplete
                          v-model="filtroCliente"
                          :items="clientesDisponibles"
                          item-text="text"
                          item-value="value"
                          label="Filtrar por cliente"
                          outlined
                          class="ml-2"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </template>

                  <template v-slot:[`item.añoAnterior`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoAnterior) }}
                  </template>
                  <template v-slot:[`item.añoActual`]="{ item }">
                    {{ "$" + formatoPrecio(item.añoActual) }}
                  </template>
                  <template v-slot:[`item.diferencia`]="{ item }">
                    <strong
                      :class="item.diferencia < 0 ? 'red--text' : 'green--text'"
                    >
                      {{ "$" + formatoPrecio(item.diferencia) }}
                    </strong>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import pako from "pako";
import Papa from "papaparse";
import VentasPorMes from "../components/VentasPorMes.vue";
import VentasPorTrimestre from "../components/VentasPorTrimestre.vue";
//import Swal from "sweetalert2";

export default {
  data() {
    return {
      items: [],
      dataLaboratorio: [],
      datosFiltrados: [],
      datosChartMes: [],
      datosChartTrimestre: [],
      datosCompLab: [],
      dataComp: [],
      laboratoriosSelected: null,

      datosDiferenciaMes: Array(12).fill(0),
      datosDiferenciaTrimestre: Array(4).fill(0),

      fechaFin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10),
      currentYear: new Date().getFullYear(),

      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Tijuana",
          value: "Tijuana",
        },
        {
          text: "Ensenada",
          value: "Ensenada",
        },
        {
          text: "La Paz",
          value: "LaPaz",
        },
        {
          text: "Obregón",
          value: "Obregon",
        },
        {
          text: "Hermosillo",
          value: "Hermosillo",
        },
      ],
      sucursalesSeleccionadas: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      //sucursalSelected: "Mexicali",
      //laboratorioSelected: {},
      laboratorioSelected: null,
      selectedMonth: new Date().getMonth() + 1,
      selectedMonth2: null,
      selectedMonth3: null,
      selectedMonth4: null,
      loadingTable: false,
      dialog: false,
      headers: [],
      meses: [
        {
          text: "Enero",
          value: 1,
        },
        {
          text: "Febrero",
          value: 2,
        },
        {
          text: "Marzo",
          value: 3,
        },
        {
          text: "Abril",
          value: 4,
        },
        {
          text: "Mayo",
          value: 5,
        },
        {
          text: "Junio",
          value: 6,
        },
        {
          text: "Julio",
          value: 7,
        },
        {
          text: "Agosto",
          value: 8,
        },
        {
          text: "Septiembre",
          value: 9,
        },
        {
          text: "Octubre",
          value: 10,
        },
        {
          text: "Noviembre",
          value: 11,
        },
        {
          text: "Diciembre",
          value: 12,
        },
      ],
      laboratorios: [], //lista de laboratorios importantes

      loadingBtn: false,
      //   itemsFiltrados: [],
      tablas: [
        "Por Sucursal",
        "Clientes de Sucursal",
        "Productos de Sucursal",
        "Productos de Clientes",
      ],
      tablaSeleccionada: "Por Sucursal", // Tabla inicial seleccionada
      comparacionClientesSucursal: [], // Datos para la tabla comparacionClientesSucursal
      comparacionProductosSucursal: [], // Datos para la tabla comparacionProductosSucursal
      comparacionProductosClientes: [], // Datos para la tabla comparacionProductosClientes
      search: "",
      filtroSucursal: "", // Filtro para sucursal
      search2: "",
      filtroSucursal2: "", // Filtro para sucursal
      search3: "",
      filtroCliente: "", // Filtro para cliente
      activarFiltroFecha: false,
      datosOriginalesClientesSucursal: [],
      datosCompletosSinFiltrar: [],
      quitarFiltros: false,

      activarFiltroFecha2: false,
      quitarFiltros2: false,
      datosOriginalesProductosSucursal: [],
      datosCompletosSinFiltrar2: [],

      activarFiltroFecha3: false,
      quitarFiltros3: false,
      datosOriginalesProductosClientes: [],
      datosCompletosSinFiltrar3: [],
    };
  },
  methods: {
    irTablaProductosClientes(item) {
      this.tablaSeleccionada = "Productos de Clientes";
      this.search3 = item.razon_social;
      this.filtroCliente = item.razon_social;
      this.selectedMonth4 = this.selectedMonth2;
    },

    async getPivoteComparaciones({ indice }) {
      try {
        let sucursalesString = "";
        if (this.sucursalesSeleccionadas.length > 0) {
          sucursalesString = this.sucursalesSeleccionadas
            .map((s) => `&sucursales=${s}`)
            .join("");
        }

        const url = `/reportes/pivot_table?fecha_inicial=${
          this.currentYear - 1
        }-01-01&fecha_final=${
          this.fechaFin
        }${sucursalesString}&indice=${indice}&columnas=year&valor=neto-desc&filtros=laboratorio=${
          this.laboratorioSelected
        }`;

        const response = await axios.get(url, { responseType: "arraybuffer" });
        const decompressedData = pako.ungzip(new Uint8Array(response.data), {
          to: "string",
        });
        const csvData = Papa.parse(decompressedData, {
          header: true,
          dynamicTyping: true,
        });

        const data = csvData.data;
        data.pop(); // elimina fila vacía

        return data;
      } catch (error) {
        console.error(error);
      }
    },
    async getClientesPorSucursal() {
      try {
        const data = await this.getPivoteComparaciones({
          indice: "razon_social",
        });

        this.datosCompletosSinFiltrar = [...data];

        const grouped = data.reduce((acc, row) => {
          const sucursal = row.sucursal
            ? row.sucursal.toUpperCase()
            : "SIN SUCURSAL";
          const cliente = row.razon_social
            ? row.razon_social.toUpperCase()
            : "SIN CLIENTE";
          const year = row.year;
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!acc[sucursal]) acc[sucursal] = {};
          if (!acc[sucursal][cliente]) acc[sucursal][cliente] = {};
          if (!acc[sucursal][cliente][year]) acc[sucursal][cliente][year] = 0;

          acc[sucursal][cliente][year] += netoDesc;
          return acc;
        }, {});

        const comparacion = [];

        Object.keys(grouped).forEach((sucursal) => {
          Object.keys(grouped[sucursal]).forEach((cliente) => {
            const años = Object.keys(grouped[sucursal][cliente])
              .map(Number)
              .sort((a, b) => a - b);
            const añoAnterior = grouped[sucursal][cliente][años[0]] || 0;
            const añoActual = grouped[sucursal][cliente][años[1]] || 0;

            comparacion.push({
              sucursal,
              razon_social: cliente,
              añoAnterior,
              añoActual,
              diferencia: añoActual - añoAnterior,
            });
          });
        });

        this.comparacionClientesSucursal = comparacion;
        console.log(this.comparacionClientesSucursal);
      } catch (error) {
        console.error("Error al obtener los clientes por sucursal:", error);
      }
    },

    procesarComparacionHastaHoy() {
      const hoy = new Date();
      const diaActual = hoy.getDate();
      const mesActual = hoy.getMonth() + 1;
      const añoActual = hoy.getFullYear();
      const añoAnterior = añoActual - 1;

      const grouped = {};

      this.datosCompletosSinFiltrar.forEach((row) => {
        if (!row.fecha) return; // Evita errores

        //console.log("Fecha:", row.fecha);

        const [año, mes, dia] = row.fecha.trim().split("-").map(Number);
        const dentroDeRango =
          (año === añoActual &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual))) ||
          (año === añoAnterior &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual)));

        if (!dentroDeRango) return;

        const sucursal = row.sucursal?.toUpperCase() || "SIN SUCURSAL";
        const cliente = row.razon_social?.toUpperCase() || "SIN CLIENTE";
        const netoDesc = parseFloat(row["neto-desc"]) || 0;

        if (!grouped[sucursal]) grouped[sucursal] = {};
        if (!grouped[sucursal][cliente]) grouped[sucursal][cliente] = {};
        if (!grouped[sucursal][cliente][año])
          grouped[sucursal][cliente][año] = 0;

        grouped[sucursal][cliente][año] += netoDesc;
      });

      const comparacion = [];

      Object.keys(grouped).forEach((sucursal) => {
        Object.keys(grouped[sucursal]).forEach((cliente) => {
          const anterior = grouped[sucursal][cliente][añoAnterior] || 0;
          const actual = grouped[sucursal][cliente][añoActual] || 0;

          comparacion.push({
            sucursal,
            razon_social: cliente,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      // Esta es una copia filtrada que puedes usar para la tabla
      this.datosOriginalesClientesSucursal = comparacion;
      console.log(
        "Datos originales filtrados:",
        this.datosOriginalesClientesSucursal
      );
    },

    procesarComparacionPorMes() {
      const añoActual = new Date().getFullYear();
      const añoAnterior = añoActual - 1;
      const mesSeleccionado = this.selectedMonth2;

      const grouped = {};

      this.datosCompletosSinFiltrar.forEach((row) => {
        if (!row.fecha) return;

        const [año, mes] = row.fecha.split("-").map(Number);

        // Filtrar por mes y año actual o anterior
        if (
          mes === mesSeleccionado &&
          (año === añoActual || año === añoAnterior)
        ) {
          const sucursal = row.sucursal?.toUpperCase() || "SIN SUCURSAL";
          const cliente = row.razon_social?.toUpperCase() || "SIN CLIENTE";
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!grouped[sucursal]) grouped[sucursal] = {};
          if (!grouped[sucursal][cliente]) grouped[sucursal][cliente] = {};
          if (!grouped[sucursal][cliente][año])
            grouped[sucursal][cliente][año] = 0;

          grouped[sucursal][cliente][año] += netoDesc;
        }
      });

      const comparacion = [];

      Object.keys(grouped).forEach((sucursal) => {
        Object.keys(grouped[sucursal]).forEach((cliente) => {
          const anterior = grouped[sucursal][cliente][añoAnterior] || 0;
          const actual = grouped[sucursal][cliente][añoActual] || 0;

          comparacion.push({
            sucursal,
            razon_social: cliente,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      this.datosOriginalesClientesSucursal = comparacion;
    },

    async getProductosPorSucursal() {
      try {
        const data = await this.getPivoteComparaciones({ indice: "nombre" });

        this.datosCompletosSinFiltrar2 = [...data];

        const grouped = data.reduce((acc, row) => {
          const sucursal = row.sucursal
            ? row.sucursal.toUpperCase()
            : "SIN SUCURSAL";
          const producto = row.nombre
            ? row.nombre.toUpperCase()
            : "SIN PRODUCTO";
          const year = row.year;
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!acc[sucursal]) acc[sucursal] = {};
          if (!acc[sucursal][producto]) acc[sucursal][producto] = {};
          if (!acc[sucursal][producto][year]) acc[sucursal][producto][year] = 0;

          acc[sucursal][producto][year] += netoDesc;
          return acc;
        }, {});

        const comparacion = [];

        Object.keys(grouped).forEach((sucursal) => {
          Object.keys(grouped[sucursal]).forEach((producto) => {
            const años = Object.keys(grouped[sucursal][producto])
              .map(Number)
              .sort((a, b) => a - b);
            const añoAnterior = grouped[sucursal][producto][años[0]] || 0;
            const añoActual = grouped[sucursal][producto][años[1]] || 0;

            comparacion.push({
              sucursal,
              nombre: producto,
              añoAnterior,
              añoActual,
              diferencia: añoActual - añoAnterior,
            });
          });
        });

        this.comparacionProductosSucursal = comparacion;
      } catch (error) {
        console.error("Error al obtener los clientes por sucursal:", error);
      }
    },

    procesarComparacionHastaHoyProductos() {
      const hoy = new Date();
      const diaActual = hoy.getDate();
      const mesActual = hoy.getMonth() + 1;
      const añoActual = hoy.getFullYear();
      const añoAnterior = añoActual - 1;

      const grouped = {};

      this.datosCompletosSinFiltrar2.forEach((row) => {
        if (!row.fecha) return; // Evita errores

        //console.log("Fecha:", row.fecha);

        const [año, mes, dia] = row.fecha.trim().split("-").map(Number);
        const dentroDeRango =
          (año === añoActual &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual))) ||
          (año === añoAnterior &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual)));

        if (!dentroDeRango) return;

        const sucursal = row.sucursal?.toUpperCase() || "SIN SUCURSAL";
        const producto = row.nombre?.toUpperCase() || "SIN PRODUCTO";
        const netoDesc = parseFloat(row["neto-desc"]) || 0;

        if (!grouped[sucursal]) grouped[sucursal] = {};
        if (!grouped[sucursal][producto]) grouped[sucursal][producto] = {};
        if (!grouped[sucursal][producto][año])
          grouped[sucursal][producto][año] = 0;

        grouped[sucursal][producto][año] += netoDesc;
      });

      const comparacion = [];

      Object.keys(grouped).forEach((sucursal) => {
        Object.keys(grouped[sucursal]).forEach((producto) => {
          const anterior = grouped[sucursal][producto][añoAnterior] || 0;
          const actual = grouped[sucursal][producto][añoActual] || 0;

          comparacion.push({
            sucursal,
            nombre: producto,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      // Esta es una copia filtrada que puedes usar para la tabla
      this.datosOriginalesProductosSucursal = comparacion;
    },

    procesarComparacionPorMesProductos() {
      const añoActual = new Date().getFullYear();
      const añoAnterior = añoActual - 1;
      const mesSeleccionado = this.selectedMonth3;

      const grouped = {};

      this.datosCompletosSinFiltrar2.forEach((row) => {
        if (!row.fecha) return;

        const [año, mes] = row.fecha.split("-").map(Number);

        // Filtrar por mes y año actual o anterior
        if (
          mes === mesSeleccionado &&
          (año === añoActual || año === añoAnterior)
        ) {
          const sucursal = row.sucursal?.toUpperCase() || "SIN SUCURSAL";
          const producto = row.nombre?.toUpperCase() || "SIN PRODUCTO";
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!grouped[sucursal]) grouped[sucursal] = {};
          if (!grouped[sucursal][producto]) grouped[sucursal][producto] = {};
          if (!grouped[sucursal][producto][año])
            grouped[sucursal][producto][año] = 0;

          grouped[sucursal][producto][año] += netoDesc;
        }
      });

      const comparacion = [];

      Object.keys(grouped).forEach((sucursal) => {
        Object.keys(grouped[sucursal]).forEach((producto) => {
          const anterior = grouped[sucursal][producto][añoAnterior] || 0;
          const actual = grouped[sucursal][producto][añoActual] || 0;

          comparacion.push({
            sucursal,
            nombre: producto,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      this.datosOriginalesProductosSucursal = comparacion;
    },

    async getProductosClientes() {
      try {
        const data = await this.getPivoteComparaciones({
          indice: "nombre&razon_social",
        });

        this.datosCompletosSinFiltrar3 = [...data];

        const grouped = data.reduce((acc, row) => {
          const producto = row.nombre
            ? row.nombre.toUpperCase()
            : "SIN PRODUCTO";
          const cliente = row.razon_social
            ? row.razon_social.toUpperCase()
            : "SIN CLIENTE";
          const year = row.year;
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!acc[producto]) acc[producto] = {};
          if (!acc[producto][cliente]) acc[producto][cliente] = {};
          if (!acc[producto][cliente][year]) acc[producto][cliente][year] = 0;

          acc[producto][cliente][year] += netoDesc;
          return acc;
        }, {});

        const comparacion = [];

        Object.keys(grouped).forEach((producto) => {
          Object.keys(grouped[producto]).forEach((cliente) => {
            const años = Object.keys(grouped[producto][cliente])
              .map(Number)
              .sort((a, b) => a - b);
            const añoAnterior = grouped[producto][cliente][años[0]] || 0;
            const añoActual = grouped[producto][cliente][años[1]] || 0;

            comparacion.push({
              nombre: producto,
              razon_social: cliente,
              añoAnterior,
              añoActual,
              diferencia: añoActual - añoAnterior,
            });
          });
        });

        this.comparacionProductosClientes = comparacion;
      } catch (error) {
        console.error("Error al obtener los productos por cliente:", error);
      }
    },

    procesarComparacionHastaHoyProductosClientes() {
      const hoy = new Date();
      const diaActual = hoy.getDate();
      const mesActual = hoy.getMonth() + 1;
      const añoActual = hoy.getFullYear();
      const añoAnterior = añoActual - 1;

      const grouped = {};

      this.datosCompletosSinFiltrar3.forEach((row) => {
        if (!row.fecha) return; // Evita errores

        //console.log("Fecha:", row.fecha);

        const [año, mes, dia] = row.fecha.trim().split("-").map(Number);
        const dentroDeRango =
          (año === añoActual &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual))) ||
          (año === añoAnterior &&
            (mes < mesActual || (mes === mesActual && dia <= diaActual)));

        if (!dentroDeRango) return;

        const producto = row.nombre?.toUpperCase() || "SIN PRODUCTO";
        const cliente = row.razon_social?.toUpperCase() || "SIN CLIENTE";
        const netoDesc = parseFloat(row["neto-desc"]) || 0;

        if (!grouped[producto]) grouped[producto] = {};
        if (!grouped[producto][cliente]) grouped[producto][cliente] = {};
        if (!grouped[producto][cliente][año])
          grouped[producto][cliente][año] = 0;

        grouped[producto][cliente][año] += netoDesc;
      });

      const comparacion = [];

      Object.keys(grouped).forEach((producto) => {
        Object.keys(grouped[producto]).forEach((cliente) => {
          const anterior = grouped[producto][cliente][añoAnterior] || 0;
          const actual = grouped[producto][cliente][añoActual] || 0;

          comparacion.push({
            nombre: producto,
            razon_social: cliente,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      // Esta es una copia filtrada que puedes usar para la tabla
      this.datosOriginalesProductosClientes = comparacion;
    },

    procesarComparacionPorMesProductosClientes() {
      const añoActual = new Date().getFullYear();
      const añoAnterior = añoActual - 1;
      const mesSeleccionado = this.selectedMonth4;

      const grouped = {};

      this.datosCompletosSinFiltrar3.forEach((row) => {
        if (!row.fecha) return;

        const [año, mes] = row.fecha.split("-").map(Number);

        // Filtrar por mes y año actual o anterior
        if (
          mes === mesSeleccionado &&
          (año === añoActual || año === añoAnterior)
        ) {
          const producto = row.nombre?.toUpperCase() || "SIN PRODUCTO";
          const cliente = row.razon_social?.toUpperCase() || "SIN CLIENTE";
          const netoDesc = parseFloat(row["neto-desc"]) || 0;

          if (!grouped[producto]) grouped[producto] = {};
          if (!grouped[producto][cliente]) grouped[producto][cliente] = {};
          if (!grouped[producto][cliente][año])
            grouped[producto][cliente][año] = 0;

          grouped[producto][cliente][año] += netoDesc;
        }
      });

      const comparacion = [];

      Object.keys(grouped).forEach((producto) => {
        Object.keys(grouped[producto]).forEach((cliente) => {
          const anterior = grouped[producto][cliente][añoAnterior] || 0;
          const actual = grouped[producto][cliente][añoActual] || 0;

          comparacion.push({
            nombre: producto,
            razon_social: cliente,
            añoAnterior: anterior,
            añoActual: actual,
            diferencia: actual - anterior,
          });
        });
      });

      this.datosOriginalesProductosClientes = comparacion;
    },

    processData() {
      let totalCurrentYear = Array(12).fill(0);
      let totalLastYear = Array(12).fill(0);
      let totalCurrentYearTrimestre = Array(4).fill(0);
      let totalLastYearTrimestre = Array(4).fill(0);

      const datosParaGraficos = this.dataLaboratorio.filter(
        (item) =>
          (this.laboratorioSelected
            ? item.laboratorio === this.laboratorioSelected
            : true) &&
          (item.year === this.currentYear - 1 || item.year === this.currentYear)
      );

      if (this.dataLaboratorio.length > 0) {
        this.datosFiltrados = datosParaGraficos
          .filter(
            (item) =>
              this.selectedMonth === 0 || item.mes === this.selectedMonth
          )
          .map((item) => ({
            year: item.year,
            mes: item.mes,
            "neto-desc": item["neto-desc"],
            laboratorio: item.laboratorio,
            sucursal: item.sucursal,
          }));

        datosParaGraficos.forEach((item) => {
          const value = parseFloat(item["neto-desc"]) || 0;
          if (item.year === this.currentYear) {
            totalCurrentYear[item.mes - 1] += value;
          } else if (item.year === this.currentYear - 1) {
            totalLastYear[item.mes - 1] += value;
          }
        });
        /*datosParaGraficos.forEach((item) => {
          if (item.year === this.currentYear) {
            totalCurrentYear[item.mes - 1] =
              parseFloat(totalCurrentYear[item.mes - 1]) +
              parseFloat(item["neto-desc"]); //.toFixed(2);
          } else if (item.year === this.currentYear - 1) {
            totalLastYear[item.mes - 1] =
              parseFloat(totalLastYear[item.mes - 1]) +
              parseFloat(item["neto-desc"]); //.toFixed(2);
          }
        });*/

        datosParaGraficos.forEach((item) => {
          const value = parseFloat(item["neto-desc"]) || 0;
          const trimestre = Math.floor((item.mes - 1) / 3);
          if (item.year === this.currentYear) {
            totalCurrentYearTrimestre[trimestre] += value;
          } else if (item.year === this.currentYear - 1) {
            totalLastYearTrimestre[trimestre] += value;
          }
        });
        /*datosParaGraficos.forEach((item) => {
          const trimestre = Math.floor((item.mes - 1) / 3);
          if (item.year === this.currentYear) {
            totalCurrentYearTrimestre[trimestre] += item["neto-desc"];
          } else if (item.year === this.currentYear - 1) {
            totalLastYearTrimestre[trimestre] += item["neto-desc"];
          }
        });*/

        this.datosChartMes = [
          {
            name: "Año anterior",
            //type: "column",
            data: totalLastYear.map((v) => Number(v) || 0),
          },
          {
            name: "Año actual",
            //type: "column",
            data: totalCurrentYear.map((v) => Number(v) || 0),
          },
        ];
        this.datosChartTrimestre = [
          {
            name: "Año anterior",
            data: totalLastYearTrimestre.map((v) => Number(v) || 0),
          },
          {
            name: "Año actual",
            data: totalCurrentYearTrimestre.map((v) => Number(v) || 0),
          },
        ];

        this.datosDiferenciaMes = totalCurrentYear.map((item, index) => {
          return Math.round(item - totalLastYear[index]);
        });

        this.datosDiferenciaTrimestre = totalCurrentYearTrimestre.map(
          (item, index) => {
            return Math.round(item - totalLastYearTrimestre[index]);
          }
        );

        const grouped = this.datosFiltrados.reduce((acc, datoVenta) => {
          const { sucursal, year, "neto-desc": netoDesc } = datoVenta;
          const suc = sucursal ? sucursal.toUpperCase() : "SIN SUCURSAL";
          if (!acc[suc]) acc[suc] = {};
          if (!acc[suc][year]) acc[suc][year] = 0;
          acc[suc][year] += parseFloat(netoDesc) || 0;
          return acc;
        }, {});

        /* const grouped = this.datosFiltrados.reduce((acc, datoVenta) => {
          const { sucursal, year, "neto-desc": netoDesc } = datoVenta;
          if (!acc[sucursal]) {
            acc[sucursal] = {};
          }
          if (!acc[sucursal][year]) {
            acc[sucursal][year] = 0;
          }
          acc[sucursal][year] += parseFloat(netoDesc) || 0; //modificado
          return acc;
        }, {});*/

        const comparacion = Object.keys(grouped).map((sucursal) => {
          const años = Object.keys(grouped[sucursal])
            .map(Number)
            .sort((a, b) => a - b);
          const añoAnterior = grouped[sucursal][años[0]] || 0;
          const añoActual = grouped[sucursal][años[1]] || 0;
          return {
            sucursal,
            añoAnterior,
            añoActual,
            diferencia: añoActual - añoAnterior,
          };
        });

        this.comparacionPorSucursal = comparacion.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.sucursal === item.sucursal)
        );
        //this.comparacionPorSucursal = comparacion;

        this.loadingTable = false;
      } else {
        this.loadingTable = false;
        alert("No hay registros para mostrar");
      }
    },

    async fetchLaboratorios() {
      try {
        const response = await axios.get(
          `/varios/get_json?nombre=laboratorios_importantes`
        );
        this.laboratorios = response.data.objeto.lista.map((lab) => ({
          text: lab,
          value: lab,
        }));
      } catch (error) {
        console.error("Error al obtener los laboratorios importantes:", error);
      }
    },
    async getReporte() {
      this.loadingBtn = true;
      if (!this.laboratorioSelected) {
        alert("Selecciona un laboratorio.");
        this.loadingBtn = false;
        return;
      }
      try {
        let sucursalesString = "";
        if (this.sucursalesSeleccionadas.length !== 0) {
          this.sucursalesSeleccionadas.forEach((sucursal) => {
            sucursalesString = sucursalesString + `&sucursales=${sucursal}`;
          });
        }

        const response = await axios.get(
          `/reportes/pivot_table?fecha_inicial=${
            this.currentYear - 1
          }-01-01&fecha_final=${
            this.fechaFin
          }&sucursales=${sucursalesString}&indice=laboratorio&valor=neto-desc&filtros=laboratorio=${
            this.laboratorioSelected
          }`,

          {
            responseType: "arraybuffer",
          }
        );

        const decompressedData = pako.ungzip(response.data, { to: "string" });
        const csvData = Papa.parse(decompressedData, {
          header: true,
          dynamicTyping: true,
        });
        const data = csvData.data;
        data.pop();

        this.dataLaboratorio = data;
        this.processData();
        this.getClientesPorSucursal();
        this.getProductosPorSucursal();
        this.getProductosClientes();
      } catch (error) {
        alert(`Error al obtener los datos`);
        console.log(error.response.data);
      } finally {
        this.loadingBtn = false;
      }
    },

    cerrarDialog() {
      this.dialog = false;
    },
    formatoPrecio(precioProducto) {
      // Formatear el número utilizando una función personalizada
      const numero = parseFloat(precioProducto);
      // console.log(numero);
      let precio = 0;

      precio = numero.toFixed(2); // Limitar a 2 decimales
      const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
      const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

      // Formatear la parte entera con separador de miles
      const parteEnteraFormateada = parteEntera.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );

      return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
    },
  },
  watch: {
    sucursalesSeleccionadas: {
      handler() {
        this.getReporte();
      },
      deep: true,
    },
    selectedMonth() {
      this.processData();
    },

    selectedMonth2(nuevoValor) {
      if (nuevoValor) {
        this.activarFiltroFecha = false;
        this.procesarComparacionPorMes();
      } else {
        this.datosOriginalesClientesSucursal = [
          ...this.comparacionClientesSucursal,
        ];
      }
    },

    activarFiltroFecha(nuevoValor) {
      if (nuevoValor) {
        this.selectedMonth2 = null;
        this.quitarFiltros = false;
        this.procesarComparacionHastaHoy();
      } else {
        this.datosOriginalesClientesSucursal = [
          ...this.comparacionClientesSucursal,
        ];
      }
    },

    quitarFiltros() {
      this.datosOriginalesClientesSucursal = [
        ...this.comparacionClientesSucursal,
      ];

      this.activarFiltroFecha = false;
      this.selectedMonth2 = null;
    },

    selectedMonth3(nuevoValor) {
      if (nuevoValor) {
        this.activarFiltroFecha2 = false;
        this.procesarComparacionPorMesProductos();
      } else {
        this.datosOriginalesProductosSucursal = [
          ...this.comparacionProductosSucursal,
        ];
      }
    },

    activarFiltroFecha2(nuevoValor) {
      if (nuevoValor) {
        this.selectedMonth3 = null;
        this.quitarFiltros2 = false;
        this.procesarComparacionHastaHoyProductos();
      } else {
        this.datosOriginalesProductosSucursal = [
          ...this.comparacionProductosSucursal,
        ];
      }
    },

    quitarFiltros2() {
      this.datosOriginalesProductosSucursal = [
        ...this.comparacionProductosSucursal,
      ];

      this.activarFiltroFecha2 = false;
      this.selectedMonth3 = null;
    },

    selectedMonth4(nuevoValor) {
      if (nuevoValor) {
        this.activarFiltroFecha3 = false;
        this.procesarComparacionPorMesProductosClientes();
      } else {
        this.datosOriginalesProductosClientes = [
          ...this.comparacionProductosClientes,
        ];
      }
    },

    activarFiltroFecha3(nuevoValor) {
      if (nuevoValor) {
        this.selectedMonth4 = null;
        this.quitarFiltros3 = false;
        this.procesarComparacionHastaHoyProductosClientes();
      } else {
        this.datosOriginalesProductosClientes = [
          ...this.comparacionProductosClientes,
        ];
      }
    },

    quitarFiltros3() {
      this.datosOriginalesProductosClientes = [
        ...this.comparacionProductosClientes,
      ];

      this.activarFiltroFecha3 = false;
      this.selectedMonth4 = null;
    },
  },

  computed: {
    clientesSucursalMostrados() {
      return this.activarFiltroFecha || this.selectedMonth2
        ? this.datosOriginalesClientesSucursal
        : this.comparacionClientesSucursal;
    },

    clientesSucursalFiltrados() {
      return this.clientesSucursalMostrados.filter((item) => {
        if (this.filtroSucursal && item.sucursal !== this.filtroSucursal) {
          return false;
        }

        if (this.search) {
          const text = this.search.toLowerCase();
          return (
            item.razon_social?.toLowerCase().includes(text) ||
            item.sucursal?.toLowerCase().includes(text)
          );
        }

        return true;
      });
    },

    productosSucursalMostrados() {
      return this.activarFiltroFecha2 || this.selectedMonth3
        ? this.datosOriginalesProductosSucursal
        : this.comparacionProductosSucursal;
    },

    productosSucursalFiltrados() {
      return this.productosSucursalMostrados.filter((item) => {
        if (this.filtroSucursal2 && item.sucursal !== this.filtroSucursal2) {
          return false;
        }

        if (this.search2) {
          const text = this.search2.toLowerCase();
          return (
            item.nombre?.toLowerCase().includes(text) ||
            item.sucursal?.toLowerCase().includes(text)
          );
        }

        return true;
      });
    },

    productosClientesMostrados() {
      return this.activarFiltroFecha3 || this.selectedMonth4
        ? this.datosOriginalesProductosClientes
        : this.comparacionProductosClientes;
    },

    productosClientesFiltrados() {
      return this.productosClientesMostrados.filter((item) => {
        if (this.filtroCliente && item.razon_social !== this.filtroCliente) {
          return false;
        }

        if (this.search3) {
          const text = this.search3.toLowerCase();
          return (
            item.razon_social?.toLowerCase().includes(text) ||
            item.nombre?.toLowerCase().includes(text)
          );
        }

        return true;
      });
    },

    sucursalesDisponibles() {
      const sucursales = [
        ...new Set(
          this.comparacionClientesSucursal.map((item) => item.sucursal)
        ),
      ];
      return sucursales.map((sucursal) => ({
        text: sucursal,
        value: sucursal,
      }));
      /*return [
        ...new Set(
          this.comparacionClientesSucursal.map((item) => item.sucursal)
        ),
      ];*/
    },
    sucursalesDisponibles2() {
      const sucursales = [
        ...new Set(
          this.comparacionProductosSucursal.map((item) => item.sucursal)
        ),
      ];
      return sucursales.map((sucursal) => ({
        text: sucursal,
        value: sucursal,
      }));
      /*return [
        ...new Set(
          this.comparacionProductosSucursal.map((item) => item.sucursal)
        ),
      ];*/
    },

    clientesDisponibles() {
      const clientes = [
        ...new Set(
          this.comparacionProductosClientes.map((item) => item.razon_social)
        ),
      ];
      return clientes.map((cliente) => ({
        text: cliente,
        value: cliente,
      }));
      /*return [
        ...new Set(
          this.comparacionProductosClientes.map((item) => item.razon_social)
        ),
      ];*/
    },

    itemsFiltrados() {
      const itemsLaboratorio = this.items.filter(
        (cliente) => cliente.laboratorio === this.laboratorioSelected
      );

      return itemsLaboratorio;
    },
    ...mapGetters(["user"]),
  },
  created() {
    this.headers = [
      { text: "Sucursal", value: "sucursal" },
      {
        text: `${this.currentYear - 1}`,
        value: "añoAnterior",
        sortable: false,
      },
      { text: `${this.currentYear}`, value: "añoActual", sortable: false },
      { text: "Diferencia", value: "diferencia", sortable: false },
    ];
    this.headersClientes = [
      {
        text: "Sucursal",
        value: "sucursal",
        class: "d-none",
        cellClass: "d-none",
      },
      { text: "Cliente", value: "razon_social" },
      { text: `${this.currentYear - 1}`, value: "añoAnterior" },
      { text: `${this.currentYear}`, value: "añoActual" },
      { text: "Diferencia", value: "diferencia" },
    ];
    this.headersProductos = [
      {
        text: "Sucursal",
        value: "sucursal",
        class: "d-none",
        cellClass: "d-none",
      },
      { text: "Producto", value: "nombre" },
      { text: `${this.currentYear - 1}`, value: "añoAnterior" },
      { text: `${this.currentYear}`, value: "añoActual" },
      { text: "Diferencia", value: "diferencia" },
    ];
    this.headersProductosClientes = [
      { text: "Cliente", value: "razon_social" },
      { text: "Producto", value: "nombre" },
      { text: `${this.currentYear - 1}`, value: "añoAnterior" },
      { text: `${this.currentYear}`, value: "añoActual" },
      { text: "Diferencia", value: "diferencia" },
    ];
    this.fetchLaboratorios();
  },
  components: { VentasPorMes, VentasPorTrimestre },
};
</script>
